import { render, staticRenderFns } from "./ArchiveItemAction.vue?vue&type=template&id=5464f862&"
import script from "./ArchiveItemAction.vue?vue&type=script&lang=js&"
export * from "./ArchiveItemAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports